<template>
    <div class="abouts">
        <div class="container">
            <h1>{{hero.title}}</h1>
            <p>{{hero.content}}</p>
        </div>
    </div>
    <div class="skills">
        <div class="container">
            <h1>{{title}}</h1>
            <div v-for="item in skill" :key="item" class="row skill">
                <div class="col-12 col-lg-6">
                    <div class="row flex-row-reverse skill1">
                        <div class="col-12 col-lg-6">
                            <img :src="item.image" alt="">
                        </div>
                        <div class="col-12 col-lg-6">
                            <h4>{{item.title}}</h4>
                        </div>
                    </div>
                </div>
                    <div class="col-12 col-lg-6">
                        <p>{{item.content}}</p>
                    </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                hero : {
                    title : 'What We Do',
                    content : 'We are a creative agency located in Batam, Indonesia. we focus on creating websites and graphic designs such as company profile websites, umkm product info websites, mobile apps design, and logo design.'
                },
                title : 'How We Do It',
                skill :[
                    {
                        title : 'PASSION & PRIDE',
                        content : 'With plenty of hard work,a genuine passion for what we do, we deliver projects we’re proud of. ',
                        image : 'https://img.icons8.com/ios/80/ffffff/fire-element--v1.png'  
                    },
                    {
                        title : 'HONESTY',
                        content : 'We see honesty as an asset.We are transparent about our approach and upfront with our views on what will make your project successful. ',
                        image : 'https://img.icons8.com/windows/80/ffffff/honesty.png'  
                    },
                    {
                        title : 'TRUE RELATIONSHIP',
                        content : 'As a small company, we get to work closely with our clients, and that’s just how we like it. We believe in communication, collaboration and a strong, long-lasting relationship. ',
                        image : 'https://img.icons8.com/ios/80/ffffff/communication.png'  
                    },
                ]

            }
        }
    }
</script>

<style scoped>
    .abouts{
        margin-top: 150px;
        margin-bottom: 300px;
        color: #ffff;
        text-align: center;
    }
    .abouts h1{
        font-weight: 700;
        font-size: 3rem;
    }
    .abouts p{
        margin: 20px auto;
        font-size: .9rem;
    }
    .skills{
        margin-bottom: 200px;
    }
    .skills h1{
        text-align: center;
        font-size: 3rem;
        font-weight: 700;
    }
    .skill{
        margin-top: 50px;
    }
    .skill p{
        font-size: .9rem;
    }
    .skill h4{
        font-weight: 600;
    }


    /* Large Desktop */
    @media(min-width: 1200px){
        .abouts p{
            width: 40%;
        }
        .skill{
            text-align: center;
            align-items: center;
            justify-content: center;
            margin-top: 150px;
            margin-left: 150px;
        }
        .skill1 img{
            padding: unset;
            margin-left: 100px;
        }
        .skill h4{
            font-size: 2.2rem;
            text-align: right;
        }
        .skill p{
            text-align: left;
            width:50%;
            margin: auto;
        }
    }

    /* Middle Desktop */
    @media(min-width: 1025px) and (max-width: 1199px){
        .abouts p{
            width: 50%;
        }
        .skill{
            text-align: center;
            align-items: center;
            justify-content: center;
            margin-top: 120px;
            margin-left: 70px;
        }
        .skill1 img{
            padding: unset;
            margin-left: 100px;
        }
        .skill h4{
            font-size: 2rem;
            text-align: right;
        }
        .skill p{
            text-align: left;
            width:50%;
            margin: auto;
        }
    }
    /* Desktop */
    @media(min-width: 992px) and (max-width: 1024px){
        .abouts p{
            width: 50%;
        }
        .skill{
            text-align: center;
            align-items: center;
            justify-content: center;
            margin-top: 120px;
            margin-left: 70px;
        }
        .skill1 img{
            padding: unset;
            margin-left: 100px;
        }
        .skill h4{
            font-size: 2rem;
            text-align: right;
        }
        .skill p{
            text-align: left;
            width:60%;
            margin: auto;
        }
    }
    /* Tablet */
    @media(min-width: 768px) and (max-width: 991px){
        .abouts p{
            width: 70%;
        }
        .skill{
            text-align: center;
            margin-top: 50px;
            width: unset;
        }
        .skill1 img{
            padding: 20px 0;
            margin: unset;
        }
        .skill h4{
            font-size: 1.8rem;
            text-align: unset;
        }
        .skill p{
            width:50%;
            margin: auto;
        }
    }
    /* Handphone */
    @media(max-width: 767px){
        .abouts p{
            width: 100%;
        }
        .skill{
            text-align: center;
            margin-top: 50px;
            width: unset;
        }
        .skill1 img{
            margin: unset;
            padding: 20px 0;
        }
        .skill h4{
            font-size: 1.8rem;
            text-align: unset;
        }
        .skill p{
            
            width: 80%;
            margin: auto;
        }
    }
</style>